import constants from 'common/constants';
import conversions from 'common/conversions';
import environments from 'constant/environments';
import imageCompression from 'browser-image-compression';
import rules from 'common/validation-rules';

export default {
  Notification: function () {
    this.id = -1;
    this.validationErrors = [];

    this.category = {
      apiName: 'category',
      error: null,
      rule: [rules.required],
      value: null,
    };
    this.title = {
      apiName: 'title',
      error: null,
      rule: [rules.required, rules.limitLength(255)],
      value: null,
    };
    this.content = {
      apiName: 'content',
      error: null,
      rule: [rules.required, rules.limitLength(65535)],
      value: null,
    };
    this.status = {
      apiName: 'status',
      error: null,
      rule: [rules.required],
      value: 'draft',
    };
    this.pushNotification = {
      apiName: 'push_notification',
      error: null,
      rule: [rules.required],
      value: 'do_not_push',
    };
    this.publishAt = {
      apiName: 'publish_at',
      error: null,
      rule: [rules.required],
      value: `${new Date().getFullYear().toString()}-${('00' + (new Date().getMonth() + 1)).slice(
        -2
      )}-${('00' + new Date().getDate()).slice(-2)}`,
    };
    this.createdAt = {
      apiName: 'created_at',
      error: null,
      rule: null,
      value: null,
    };
    this.updatedAt = {
      apiName: 'updated_at',
      error: null,
      rule: null,
      value: null,
    };
    this.attachedFiles = {
      apiName: 'attached_files',
      csvName: null,
      error: null,
      rule: null,
      value: [],
    };

    /**
     * 商品画像を生成する
     * @param {*} file 画像ファイル
     * @returns N/A
     */
    this.createFile = async function (file) {
      if (!file) return;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      await new Promise((resolve) => (reader.onload = () => resolve()));
      const dataURI = reader.result;
      const base64File = dataURI.substring(dataURI.indexOf(',') + 1);
      // base64Imageリストに追加
      if (this.attachedFiles.value) {
        this.attachedFiles.value.push({
          name: file.name,
          base64File: base64File,
        });
      }

      // console.log('---');
      // this.attachedFiles.value.forEach(function (element, index) {
      //   console.log(`index: ${index} element.name: ${element.name} element.base64File: ${element.base64File.slice(0, 50)}...`);
      // });
    };

    /**
     * ファイルを取得する
     * @param {*} name ファイル名
     * @returns
     */
    this.getFile = function (name) {
      if (!name || !this.attachedFiles.value) return null;
      const files = this.attachedFiles.value.filter((file) => {
        return file.name === name;
      });
      return files.length > 0 ? files[0] : null;
    };

    /**
     * ファイルを削除する
     * @param {*} name ファイル名
     * @returns
     */
    this.removeFile = function (name) {
      if (!name || !this.attachedFiles.value) return;
      this.attachedFiles.value = this.attachedFiles.value.filter((image) => {
        return image.name !== name;
      });
    };

    /**
     * API登録時に使用するリクエストボディを取得する
     * @returns リクエストボディ
     */
    this.getRequestBody = function () {
      let notification = {};
      Object.keys(this).forEach((key) => {
        if (typeof this[key] !== 'function' && this[key].apiName) {
          switch (this[key].apiName) {
            case 'attached_files':
              let attachedFiles = [];
              this[key].value.forEach(function (file) {
                attachedFiles.push({
                  name: file.name,
                  base64_file: file.base64File,
                });
              });
              notification['attached_files'] = attachedFiles;
              break;
            case 'created_at':
            case 'updated_at':
              break;
            default:
              notification[this[key].apiName] = this[key].value;
          }
        }
      });
      let body = notification;
      // if (environments.isDevelop()) console.log(`body: ${JSON.stringify(body, null, '\t')}`);
      return body;
    };

    /**
     * APIから取得したデータをセットする
     * @param {*} api APIから取得した商品情報
     */
    this.setApiData = function (api) {
      // if (environments.isDevelop()) console.log('[notification.js] setApiData called.')
      // if (environments.isDevelop()) console.log(`[notification.js] api: ${JSON.stringify(api, null, '\t')}`)

      if (!api) return;
      this.id = api['id'];
      Object.keys(this).forEach((key) => {
        if (typeof this[key] !== 'function' && this[key].apiName) {
          switch (this[key].apiName) {
            case 'attached_files':
              let files = [];
              if (api[this[key].apiName]) {
                api[this[key].apiName].forEach(function (file) {
                  files.push({
                    name: file.name,
                    base64File: file.base64_file,
                  });
                });
              }
              this[key].value = files;
              break;
            default:
              if (
                api[this[key].apiName] ||
                api[this[key].apiName] === 0 ||
                api[this[key].apiName] === false
              )
                this[key].value = api[this[key].apiName];
          }
        }
      });
      // if (environments.isDevelop()) console.log(`[notification.js] this: ${JSON.stringify(this, null, '\t')}`)
    };
  },
};
